/**
 * Created by mac-mini3 on 20/06/17.
 */
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {A11yModule} from '@angular/material';
import {MdTableModule} from '@angular/material';
import {MdSortModule} from '@angular/material';
import {MdPaginatorModule} from '@angular/material';
import {MdNativeDateModule} from '@angular/material';
import {MdExpansionModule} from '@angular/material';
import {CompatibilityModule} from '@angular/material';
import {MdAutocompleteModule} from '@angular/material';
import {MdButtonToggleModule} from '@angular/material';
import {MdButtonModule} from '@angular/material';
import {MdCheckboxModule} from '@angular/material';
import {MdDialogModule} from '@angular/material';
import {MdListModule} from '@angular/material';
import {MdGridListModule} from '@angular/material';
import {MdCardModule} from '@angular/material';
import {MdChipsModule} from '@angular/material';
import {MdIconModule} from '@angular/material';
import {MdInputModule} from '@angular/material';
import {MdMenuModule} from '@angular/material';
import {MdProgressSpinnerModule} from '@angular/material';
import {MdProgressBarModule} from '@angular/material';
import {MdRadioModule} from '@angular/material';
import {MdRippleModule} from '@angular/material';
import {MdSelectModule} from '@angular/material';
import {MdSlideToggleModule} from '@angular/material';
import {MdSliderModule} from '@angular/material';
import {MdSidenavModule} from '@angular/material';
import {MdSnackBarModule} from '@angular/material';
import {MdTabsModule} from '@angular/material';
import {MdToolbarModule} from '@angular/material';
import {MdTooltipModule} from '@angular/material';
import {OverlayModule} from '@angular/cdk/overlay';
import {PlatformModule} from '@angular/cdk/platform';
import {StyleModule} from '@angular/material';
import { CdkTableModule } from '@angular/cdk/table';

import {MdDatepickerModule} from '@angular/material';
import {DateAdapter, MD_DATE_FORMATS} from '@angular/material';
import {MyDateAdapter, MY_DATE_FORMATS} from '../app-settings';


const MATERIAL_MODULES = [
    CommonModule,
    MdAutocompleteModule,
    MdButtonModule,
    MdCardModule,
    MdChipsModule,
    MdCheckboxModule,
    MdGridListModule,
    MdInputModule,
    MdListModule,
    MdProgressBarModule,
    MdProgressSpinnerModule,
    MdRippleModule,
    MdSelectModule,
    MdSidenavModule,
    MdTabsModule,
    MdToolbarModule,

    MdDatepickerModule,

    // These modules include providers.
    A11yModule,
    MdTableModule,
    MdSortModule,
    MdPaginatorModule,
    MdNativeDateModule,
    MdExpansionModule,
    CdkTableModule,
    CompatibilityModule,
    MdButtonToggleModule,
    MdDialogModule,
    MdIconModule,
    MdMenuModule,
    MdRadioModule,
    MdSliderModule,
    MdSlideToggleModule,
    MdSnackBarModule,
    MdTooltipModule,
    OverlayModule,
    PlatformModule,
    StyleModule
];

@NgModule({
    imports: MATERIAL_MODULES,
    exports: MATERIAL_MODULES,
    providers: [
        {provide: DateAdapter, useClass: MyDateAdapter},
        {provide: MD_DATE_FORMATS, useValue: MY_DATE_FORMATS},
    ],
})
export class MyMaterialModule {
}


// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/common/my-material.module.ts